// src/components/TemplateWorkspace/createWorkspace.js
import { getFunctions, httpsCallable } from 'firebase/functions';

// Initialize Firebase Functions
const functions = getFunctions();
const createWorkspaceCallable = httpsCallable(functions, 'createWorkspace');

/**
 * Function to create a new workspace via Firebase Cloud Functions
 * @param {Object} params - Parameters for workspace creation
 * @returns {Promise<string>} - Returns the content_id upon success
 */
const createWorkspace = async ({
  user,
  workspaceTitle,
  workspaceId = null,
  isScTimestampsEnabled = true,
  isScSummaryEnabled = true,
  isScTitlesEnabled = false,
  isScTagsEnabled = false,
}) => {
  // Prepare workspace data with empty maps at index "0"
  const workspaceData = {
    createdBy: user.uid,
    workspaceTitle,
    isSCTimestampsEnabled: isScTimestampsEnabled,
    isSCSummaryEnabled: isScSummaryEnabled,
    isSCTitlesEnabled: isScTitlesEnabled,
    isSCTagsEnabled: isScTagsEnabled,
    isTranscriptAvailable: false,
    ...(workspaceId ? { workspaceId } : {}),
  };

  try {
    // Call Firebase function to create workspace
    const response = await createWorkspaceCallable({ workspaceData });

    // Clear local storage cache for the user's workspace videos
    const localStorageKey = `videoCache_${user.uid}_WorkspaceVideos`;
    localStorage.removeItem(localStorageKey);

    return response.data.content_id; // Ensure your Firebase function returns the content_id
  } catch (error) {
    throw error;
  }
};

export { createWorkspace };
